import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// locales
import ThemeLocalization from './locales';
// components
import SnackbarProvider from './components/snackbar';
import { ThemeSettings } from './components/settings';
import { MotionLazyContainer } from './components/animate';
import ScrollToTop from './components/scroll-to-top';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MotionLazyContainer>
        <ThemeProvider>
            <ThemeSettings>
            <ThemeLocalization>
                <SnackbarProvider>
                <Router>
                    <ScrollToTop/>
                </Router>
                </SnackbarProvider>
            </ThemeLocalization>
            </ThemeSettings>
        </ThemeProvider>
        </MotionLazyContainer>
    </LocalizationProvider>
  );
}
